import { render } from "./LoadingCover.vue?vue&type=template&id=ac890118&scoped=true"
import script from "./LoadingCover.vue?vue&type=script&lang=js"
export * from "./LoadingCover.vue?vue&type=script&lang=js"

import "./LoadingCover.vue?vue&type=style&index=0&id=ac890118&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac890118"]])

export default __exports__